import { Link } from 'react-router-dom';
import { Shield, Users, Scale, TreePine, ArrowRight, Check } from 'lucide-react';
import { Button } from '../components/ui/button';

const ABSTRACT_BG = "https://customer-assets.emergentagent.com/job_protect-florida-now/artifacts/ppi2v49t_9D14A9FD-5222-4C7E-8965-AADBD6B54C57.PNG";

const programs = [
  {
    title: 'Membership', icon: Users, path: '/programs/membership', color: 'bg-navy',
    desc: 'Join the movement at $250/month. Access exclusive benefits, member portal, and direct participation in protecting Florida.',
    features: ['Member Portal Access', 'Exclusive Updates', 'Voting Rights', 'Community Events']
  },
  {
    title: 'Seat at the Table', icon: Shield, path: '/programs/seat-at-the-table', color: 'bg-forest',
    desc: 'A Voice for Our Land, Our Wildlife, and Our Waters. Not on the sidelines. At the table where decisions are made.',
    features: ['Early Access to Decisions', 'Inside Information', 'Unified Voice', 'Direct Influence']
  },
  {
    title: 'Legal Defense Fund', icon: Scale, path: '/programs/legal-defense-fund', color: 'bg-navy',
    desc: 'Pool resources to fund legal action protecting Florida communities from harmful development and environmental damage.',
    features: ['Community Legal Action', 'Environmental Protection', 'Rights Defense', 'Expert Legal Team']
  },
  {
    title: 'Priority Zones', icon: TreePine, path: '/programs/priority-zones', color: 'bg-forest',
    desc: 'Strategic land preservation mapping to identify and protect critical areas across Florida.',
    features: ['Land Mapping', 'Wildlife Corridors', 'Water Protection', 'Strategic Preservation']
  },
];

export default function Programs() {
  return (
    <div className="pt-16" data-testid="programs-page">
      {/* Header with branded image */}
      <section className="pt-8 pb-10 bg-[#FAFAFA]">
        <div className="max-w-[1200px] mx-auto px-4">
          <img src={ABSTRACT_BG} alt="Safe Florida Programs - Board Member Recruitment" className="w-full h-auto block rounded-xl" style={{ boxShadow: '0 4px 14px rgba(0,0,0,0.08)' }} />
        </div>
        <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-8">
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-gold font-body mb-3">Our Programs</p>
          <h1 className="text-4xl sm:text-5xl font-heading font-bold text-navy mb-4">Programs & Initiatives</h1>
          <p className="text-lg text-gray-700 font-body max-w-2xl">Comprehensive programs designed to protect, preserve, and strengthen Florida communities.</p>
        </div>
      </section>

      {/* Programs Grid */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-8">
            {programs.map(({ title, icon: Icon, path, color, desc, features }) => (
              <div key={title} className="border border-gray-200 rounded-lg overflow-hidden card-hover" data-testid={`program-${title.toLowerCase().replace(/\s+/g, '-')}`}>
                <div className={`${color} p-6`}>
                  <Icon className="w-8 h-8 text-gold mb-3" />
                  <h3 className="text-2xl font-heading font-bold text-white">{title}</h3>
                </div>
                <div className="p-6">
                  <p className="text-base text-gray-700 font-body leading-relaxed mb-4">{desc}</p>
                  <ul className="space-y-2 mb-6">
                    {features.map(f => (
                      <li key={f} className="flex items-center gap-2 text-sm font-body text-gray-600">
                        <Check className="w-4 h-4 text-forest flex-shrink-0" /> {f}
                      </li>
                    ))}
                  </ul>
                  <Link to={path}>
                    <Button className="btn-primary-safe font-body w-full justify-center">
                      Learn More <ArrowRight className="w-4 h-4 ml-2" />
                    </Button>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
